import React, { useState } from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../utils/SectionProps";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import data from "../../data/partners";
import { t } from "i18next";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const Partners = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "partners-section section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
);

  const innerClasses = classNames(
    "partners-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

 const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: { slidesToShow: 2, arrows: false },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1, arrows: false },
      },
    ],
  };

  const [items] = useState(data);

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="partners-slider-container">
            <Slider {...settings}>
              {items.map(({ id, name, image, website, web }) => (
                <div key={id} className="partner-item-wrapper">
                  <div className="partner-card">
                    
                    {/* Logo Section */}
                    <div className="partner-card-header">
                      <div className="partner-logo-box">
                        <img src={image} alt={name} className="partner-logo" />
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="partner-card-body">
                      <h4 className="partner-name">{name}</h4>
                      
                      <div className="partner-link-group">
                        <span className="partner-label">{t("VisitWebsite")}:</span>
                        <a
                          href={website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="partner-link"
                        >
                          {web}
                        </a>
                      </div>
                    </div>
                    
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

Partners.propTypes = propTypes;
Partners.defaultProps = defaultProps;

export default Partners;